/* eslint-disable */
export default function humanFileSize(size) {
  if(size) {
    const i = Math.floor( Math.log(size) / Math.log(1024) );
    return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + '' + ['b', 'Kb', 'Mb', 'Gb', 'Tb'][i];
  } return '0Kb';
};